import { 
    postData, 
    getDataWithParams,
    destroyData
} from '@/store/api/method-mbkm'

const requestInit = {
    page: 1,
    show: 10,
    sortBy: null,
    sorting: null,
    search: null,
}
const itemInit = {
    id: null,
    laboratory_id: null,
    study_course_id: null,
    student_id: null,
    username: null,
    semester_id: null,
    status: 0,
    input_type: null,
    npm: null,
    semesterId: null,
    bank_name: null,
    bank_account: null,
    bank_number: null,
    bank_branch: null,
    id_number: null,
    address: null,
    phone_number: null,
    reg_file_link: null,

}

const initialState = () => ({
    msg: null,
    status: 0,
    data: {},
    study_course_name : null,
    phase: null,
    semester_info: null,
    request: {...requestInit},
    item: {...itemInit},
    registrationStatus: [
        {
            status: 0,
            label: 'Tahap Pendaftaran',
            type: 'primary'
        },
        {
            status: 1,
            label: 'Pelaksanaan dan Penilaian Ujian',
            type: 'warning2'
        },
        {
            status: 3,
            label: 'Diterima',
            type: 'success'
        },
        {
            status: 4,
            label: 'Cadangan',
            type: 'secondary'
        },
        {
            status: 91,
            label: 'Ditolak',
            type: 'danger'
        },
    ]
})
const state = initialState
 
const getters = {
    getMsg: state => state.msg,
    getStatus: state => state.status,
    getData: state => state.data || {},
    getRequest: state => state.request,
    getItem: state => state.item,
    getRegistrationStatus: state => (status) => state.registrationStatus.find(x => x.status == status),
    getStudyCourseName: state => state.study_course_name,
    getPhase: state => state.phase,
    getSemesterInfo: state => state.semester_info
}

const actions = {
    resetRequest({commit}){
        commit('SET_REQUEST',{...requestInit})
    },
    resetItem({commit}){
        commit('SET_ITEM',{...itemInit})
    },
    setItem({commit}, value){
        commit('SET_ITEM',{...value})
    },
    async storeByLaboran({commit}, data) {
        try {
            const payload = {...data}
            delete payload.id
            const response = await postData('/registrationassistant/laboran',payload);
            commit('SET_RESPONSE', response.data);
        } catch (err) {
            if(err.response){
                commit('SET_FAILED_MESSAGE', err.response);
            }else{
                commit('SET_FAILED')
            }
        }
    },
    async storeByMahasiswa({commit}, data) {
        try {
            const payload = {...data}
            delete payload.id
            const response = await postData('/registrationassistant/student/'+data.oprec_detail_id,payload);
            commit('SET_RESPONSE', response.data);
        } catch (err) {
            if(err.response){
                commit('SET_FAILED_MESSAGE', err.response);
            }else{
                commit('SET_FAILED')
            }
        }
    },
    async fetchData({commit, state}){
        try {
            const response = await getDataWithParams('/registrationassistant',state.request);
            commit('SET_RESPONSE', response.data);
            commit('SET_DATA_MAHASISWA', response.data.data);
        } catch (err) {
            if(err.response){
                commit('SET_FAILED_MESSAGE', err.response);
            }else{
                commit('SET_FAILED')
            }
        }
    },
    async update({commit}, data) {        
        try {
            const url = `/registrationassistant/update-mahasiswa/${data.id}`
            const payload = {
                ...data
            }
            delete payload.id
            const response = await postData(url,payload);
            commit('SET_RESPONSE', response.data);
        } catch (err) {
            if(err.response){
                commit('SET_FAILED_MESSAGE', err.response);
            }else{
                commit('SET_FAILED')
            }
        }
    },
    async updateByLaboran({commit}, data) {        
        try {
            const url = `/registrationassistant/update-laboran/${data.id}`
            const payload = {
                ...data
            }
            delete payload.id
            const response = await postData(url,payload);
            commit('SET_RESPONSE', response.data);
        } catch (err) {
            if(err.response){
                commit('SET_FAILED_MESSAGE', err.response);
            }else{
                commit('SET_FAILED')
            }
        }
    },
    async destroy({commit}, data) {
        try {
            const url = `/registrationassistant/${data.id}`
            const response = await destroyData(url);
            commit('SET_RESPONSE', response.data);
        } catch (err) {
            if(err.response){
                commit('SET_FAILED_MESSAGE', err.response);
            }else{
                commit('SET_FAILED')
            }
        }
    },
    async getDataByOprec({commit, state}, oprecDetailId){
        try {
            const response = await getDataWithParams('/registrationassistant/'+oprecDetailId,state.request);
            commit('SET_RESPONSE', response.data);
            commit('SET_DATA_NON_MAHASISWA', response.data.data);
        } catch (err) {
            if(err.response){
                commit('SET_FAILED_MESSAGE', err.response);
            }else{
                commit('SET_FAILED')
            }
        }
    },
    resetState({commit}){
        commit('resetState')
    }
}

const mutations = {
    SET_FAILED(state) {
        state.msg = 'Jaringan Bermasalah'
        state.status = 0
    },
    SET_FAILED_MESSAGE(state, error) {
        state.msg = error?.data?.msg || 'Jaringan Bermasalah'
        state.status = error?.data?.status || 0
    },
    SET_RESPONSE(state, response) {
        state.msg = response.msg
        state.status = response.status
    },
    SET_DATA_MAHASISWA(state, response) {
        state.data = response
    },
    SET_DATA_NON_MAHASISWA(state, response) {
        state.data = response.data
        state.study_course_name = response.study_course_name
        state.phase = response.phase
        state.semester_info = response.semester
    },
    SET_REQUEST(state, value){
        state.request = value
    },
    SET_ITEM(state, value){
        state.item = value
    },
    resetState (state) {
        const initial = initialState()
        Object.keys(initial).forEach(key => { state[key] = initial[key] })
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
